/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cognito_Invitation_SubjectInputs */

const en_cognito_invitation_subject = /** @type {(inputs: Cognito_Invitation_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your temporary password for Recobra`)
};

const pt_br2_cognito_invitation_subject = /** @type {(inputs: Cognito_Invitation_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua senha temporária do Recobra`)
};

/**
* | output |
* | --- |
* | "Your temporary password for Recobra" |
*
* @param {Cognito_Invitation_SubjectInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cognito_invitation_subject = /** @type {((inputs?: Cognito_Invitation_SubjectInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cognito_Invitation_SubjectInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cognito_invitation_subject(inputs)
	return pt_br2_cognito_invitation_subject(inputs)
});